module.exports = __webpack_public_path__ + "img/site.cf57c720.svg";